import { useQueryString } from "@ugg/shared/hooks/use-query-string";
import { SPECIAL_TIER_LIST_PAGES, TIER_LIST_PAGES } from "@ugg/shared/pages/tier-list-pages";
import { useValidateQueryParams } from "@ugg/shared/query-params/params-helpers";
import { validParams } from "@ugg/shared/query-params/valid-params";

// ─────────────────────────────────────────────────────────────────────
// Reads the URL query string and validates it against a tier-list page's
// valid-params entry, returning both the validated dict and the resolved
// patch.
//
// Every custom-mode tier-list container opened with the same five lines
// of boilerplate. Beyond the duplication, the resolved `patch` matters:
// `validateQueryParams(..., keepDefaultParams = true)` falls back to the
// latest patch when the URL omits `?patch=`, and the hooks that take an
// explicit `patch` option need that resolved value, not the raw (absent)
// query param.
// ─────────────────────────────────────────────────────────────────────

export function useValidatedTierListParams(page: TIER_LIST_PAGES | SPECIAL_TIER_LIST_PAGES) {
  const queryParams = useQueryString();
  const validateQueryParams = useValidateQueryParams(validParams);
  const validated = validateQueryParams(page, queryParams, true);

  return { queryParams, validated, patch: validated.patch as string | undefined };
}
